<template>
    <div class="conditional-select">
        <form-field-select
                :facets="['base','form-select']"
                :items="items"
                :messages="messages"
                :has-floating-label="true"
                v-bind="$attrs"
                v-model="value"
        />
        <div class="conditional-select--conditional-field"
                v-if="value && value !== 'general'">
            <slot :name="slotName" :messages="messages"/>
        </div>
    </div>
</template>

<script>
    import FormFieldSelect from 'framework/global-components/dyn/form/form-field-select/form-field-select';

    export default {
        components: { FormFieldSelect },
        props: {
            /** @type {IFieldItem[]} */
            items: {
                type: Array,
                required: true,
            },

            messages: {
                type: Object,
                default: () => {
                },
            },
        },

        data() {
            return {
                value: '',
            };
        },

        computed: {
            slotName() {
                return this.value;
            },
        },
    };
</script>
